import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CenterModalWrapper } from '@/components/ModalTypes/center';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import { APP_LINKS } from '@/helpers/links';
import { MyLink } from '@/components/MyLink';
import { useApplyForRefin } from '@/query/queries/loan/useApplyForRefin';
import { REFIN_STATUSES } from '@/helpers/constants';
import { prettyFloatMoney } from '@/helpers/utils';
import { prettyDate } from '@/helpers/date';
import { DATE_FORMAT_MMMM_YYYY } from '@/helpers/common';
import IconClose from './close.svg';
import s from './index.module.scss';

export const ApplyRefinModal = ({ loan, onClose }) => {
  const [success, setSuccess] = useState(loan.refinancing_info.status === REFIN_STATUSES.applied);
  const { mutateAsync: apply } = useApplyForRefin();
  const ref = useRef(null);
  const { t } = useTranslation('loans');

  useOutsideClick(ref, onClose, true);

  const onApply = async () => {
    const payload = {
      fundraising: loan.fundraising_id,
      refinancing_option: loan.refinancing_info.available_option_id,
    };
    const res = await apply(payload);
    if (res?.last_payment_amount) {
      setSuccess(true);
    }
  };

  return (
    <CenterModalWrapper onClose={onClose}>
      <div className={s.wrapper} ref={ref}>
        {!success && (
          <img
            src={IconClose}
            alt="close"
            width={12}
            height={12}
            className={s.close_btn}
            onClick={onClose}
          />
        )}
        <div className={s.title}>
          {success ? t('apply_refin_modal.applied') : t('apply_refin_modal.apply')}
        </div>
        <div className={s.desc}>
          {t('apply_refin_modal.desc', {
            amount: prettyFloatMoney(loan.refinancing_info.last_payment_amount),
            date: prettyDate(loan.refinancing_info.fundraising_start_date, DATE_FORMAT_MMMM_YYYY),
          })}
        </div>
        {!success && <div className={s.note}>{t('apply_refin_modal.note')}</div>}
        {success ? (
          <div className={s.controls}>
            <button className={s.success_btn} type="button" onClick={onClose}>
              {t('apply_refin_modal.wonderful')}
            </button>
          </div>
        ) : (
          <div className={s.controls}>
            <MyLink href={APP_LINKS.loanTermsRefinancing()} className={s.learn_btn}>
              {t('apply_refin_modal.learn_more')}
            </MyLink>
            <button className={s.apply_btn} type="button" onClick={onApply}>
              {t('apply_refin_modal.apply')}
            </button>
          </div>
        )}
      </div>
    </CenterModalWrapper>
  );
};
